module.exports = __webpack_public_path__ + "media/images/home/concept_1-bb4dfe5974d928e25aad995179433693.png";